var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableRow',[_c('TableCell',{staticClass:"is-narrow"},[_vm._v(" "+_vm._s(_vm.game.name)+" ")]),_c('TableCell',{staticClass:"has-text-grey"},[_c('small',[_vm._v(_vm._s(_vm.game.note))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }